// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingFrame_wrap__oxcGN"};